module.exports = __webpack_public_path__ + "img/ghl-dark-logo.ddb37978.svg";